import React, { useState } from "react";
import "./style.css";
import { useLocation } from "react-router-dom";
import Navigation, { getContainerClass } from "../../components/navigation/navigation";
import { Eye, EyeOff } from "lucide-react";
import { changePassword } from "../../services/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from '@mui/material';
// import Header from "../../components/header/header";
import Cover from "../../components/cover/cover";
import { Container } from "react-bootstrap";

const AccountSetting = () => {
  const location = useLocation();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = async () => {
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    try {
      const response = await changePassword({
        oldPassword,
        newPassword
      });

      if (response.data.status) {
        toast.success("Password changed successfully");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(response.data.message || "Failed to change password");
      }
    } catch (error) {
      toast.error("Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const breadcrumb = ["Home", "Account Settings"];

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="accountsettings" />
        <Container className="facilities-container">
          <h1 className="container-title">Account Settings</h1>
          <div className="account-setting-form">
            <h2>Update Password</h2>
            <p className="form-description">
              Enter your current password and choose a new one.
            </p>
            <div className="password-form">
              <div className="input-wrapper">
                <input
                  type={showOldPassword ? "text" : "password"}
                  placeholder="Old password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
                <span
                  className="toggle-icon"
                  onClick={() => setShowOldPassword(!showOldPassword)}
                >
                  {showOldPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
              </div>

              <div className="input-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <span
                  className="toggle-icon"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
              </div>

              <div className="input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  className="toggle-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
              </div>

              <button onClick={handlePasswordChange} disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Save Changes"}
              </button>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default AccountSetting;
